import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { NotificationBannerComponent } from './notification-banner.component';
import { MwNotificationBannerActionsDirective } from './notification-banner.directives';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  exports: [NotificationBannerComponent, MwNotificationBannerActionsDirective],
  declarations: [
    NotificationBannerComponent,
    MwNotificationBannerActionsDirective,
  ],
  providers: [],
})
export class NotificationBannerModule {}
